import { CustomElement } from 'aurelia';

import Template from './about.html';

export default CustomElement.define({
  name: 'about-page',
  template: Template
}, class {});
